import { processService } from './processService';
import { ActivityOutputDTO, ActivityFilterParams } from './types';
import createEntitySlice from '@services/createEntitySlice';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse, ApiError } from '@/types/api';

// Create the base entity slice
const {
  reducer: processReducer,
  actions: processActions,
  fetchAll: fetchAllActivities,
  fetchById: fetchActivityById,
  createEntity: createActivity,
  updateEntity: updateActivity,
  deleteEntity: deleteActivity,
} = createEntitySlice<ActivityOutputDTO>('process', processService);

// Create a specialized thunk for fetching activities with filters
const fetchActivities = createAsyncThunk(
  'process/fetchActivities',
  async (filters: ActivityFilterParams, { rejectWithValue }) => {
    try {
      const response = await processService.fetchActivities(filters);
      // Check if the response is an ApiResponse and not an ApiError
      if ('data' in response) {
        return response.data;
      }
      return rejectWithValue(response);
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export {
  processReducer,
  processActions,
  fetchAllActivities,
  fetchActivities, // Custom thunk with filters
  fetchActivityById,
  createActivity,
  updateActivity,
  deleteActivity,
}; 